export const STORAGE_KEY = 'porsche-shader-params'
export const FOLDERS_KEY = 'porsche-shader-folders'
export const PRESETS_KEY = 'porsche-shader-presets'

export const defaultParams = {
    // Scene
    backgroundColor: '#ffffff',
    exposure: 1.0,
    toneMapping: 4,

    // Camera
    enableZoom: true,
    enablePan: true,
    enableRotate: true,
    autoRotate: true,
    autoRotateSpeed: 1.0,

    // Lightformers
    lightformerIntensityTop: 8,
    lightformerIntensitySide: 5,
    lightformerSpeed: 1.0,
    envMapIntensity: 1.5,

    // Noise mask
    noiseScale: 3.0,
    noiseSpeed: 0.3,
    noiseThreshold: 0.5,
    noiseSoftness: 0.1,

    // Pixelation
    pixelSize: 3,

    // Mode: 0 = dithering, 1 = ascii
    mode: 0,

    // Toon
    toonEnabled: true,
    toonLevels: 4,
    toonColor1: '#1a1a2e',
    toonColor2: '#16213e',
    toonColor3: '#0f3460',
    toonColor4: '#e94560',

    // Pixel overlay
    showPixelUnderneath: true,
    charBrightnessDelta: 0.3,
    charDarker: true,

    // Mask
    maskModelOnly: true,

    materialMode: false,

    // Mouse trail (stick in water)
    trailRadius: 0.06,
    trailStrength: 1.0,
    trailDissipation: 0.985,
    trailDiffusion: 0.12,
    trailSoftness: 0.7,
    trailIntensity: 1.5,
}
